import {
  createInterceptorCondition,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  type IncludeBearerTokenCondition,
  provideKeycloak,
} from 'keycloak-angular';
import { type EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../auth';

const apiCondition = createInterceptorCondition<IncludeBearerTokenCondition>({
  urlPattern: /^(.*)(\/?)api\/v1(\/.*)$/i,
});

export function provideAuth(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideKeycloak({
      config: {
        url: environment.keycloak.url,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId,
      },
      initOptions: {
        checkLoginIframe: environment.production,
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: `${window.location.origin}${environment.app_path}/assets/silent-check-sso.html`,
      },
      providers: [
        {
          provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
          useValue: [apiCondition],
        },
      ],
    }),
    provideAppInitializer(() => inject(AuthService).init()),
  ]);
}
